"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_ID_TO_NAME_MAP = exports.EAppId = void 0;
var EAppId;
(function (EAppId) {
    // Products
    EAppId["TE_ACTIVITIES"] = "TE_ACTIVITIES";
    EAppId["TE_ALLOCATE"] = "TE_ALLOCATE";
    EAppId["TE_AUTOPILOT"] = "TE_AUTOPILOT";
    EAppId["TE_ADMIN"] = "TE_ADMIN";
    EAppId["TE_CORE"] = "TE_CORE";
    EAppId["TE_CURRICULUM"] = "TE_CURRICULUM";
    EAppId["TE_DATA_MANAGER"] = "TE_DATA_MANAGER";
    EAppId["TE_DEBIT"] = "TE_DEBIT";
    EAppId["TE_EVALUATION"] = "TE_EVALUATION";
    EAppId["TE_EXAM"] = "TE_EXAM";
    EAppId["TE_EXAM_V3"] = "TE_EXAM_V3";
    EAppId["TE_HUB"] = "TE_HUB";
    EAppId["TE_PLAN"] = "TE_PLAN";
    EAppId["TE_PREFERENCES"] = "TE_PREFERENCES";
    EAppId["TE_REGISTRATION"] = "TE_REGISTRATION";
    EAppId["TE_REPORTING"] = "TE_REPORTING";
    EAppId["TE_RESERVE"] = "TE_RESERVE";
    EAppId["TE_STUDY_GUIDE"] = "TE_STUDY_GUIDE";
    EAppId["TE_STUDY_PLANNER"] = "TE_STUDY_PLANNER";
    EAppId["TE_SEAT_MANAGEMENT"] = "TE_SEAT_MANAGEMENT";
    EAppId["TE_STATISTICS"] = "TE_STATISTICS";
    EAppId["TE_VIEWER"] = "TE_VIEWER";
    // Supporting apps
    EAppId["JAVA_CLIENT"] = "JAVA_CLIENT";
    EAppId["TE_AM"] = "TE_AM";
    EAppId["TE_PORTAL"] = "TE_PORTAL";
    EAppId["TE_REST"] = "TE_REST";
    EAppId["TE_SERVER_THREAD"] = "TE_SERVER_THREAD";
    EAppId["TE_SOAP"] = "TE_SOAP";
})(EAppId = exports.EAppId || (exports.EAppId = {}));
exports.APP_ID_TO_NAME_MAP = {
    // Products
    [EAppId.TE_ACTIVITIES]: 'Activities',
    [EAppId.TE_ALLOCATE]: 'Allocate',
    [EAppId.TE_AUTOPILOT]: 'Autopilot',
    [EAppId.TE_ADMIN]: 'Admin',
    [EAppId.TE_CORE]: 'Core',
    [EAppId.TE_CURRICULUM]: 'Curriculum',
    [EAppId.TE_DATA_MANAGER]: 'Data Manager',
    [EAppId.TE_DEBIT]: 'Debit',
    [EAppId.TE_EVALUATION]: 'Evaluation',
    [EAppId.TE_EXAM]: 'Exam',
    [EAppId.TE_EXAM_V3]: 'Exam V3',
    [EAppId.TE_HUB]: 'Hub',
    [EAppId.TE_PLAN]: 'Plan',
    [EAppId.TE_PREFERENCES]: 'Preferences',
    [EAppId.TE_REGISTRATION]: 'Registration',
    [EAppId.TE_REPORTING]: 'Reporting',
    [EAppId.TE_RESERVE]: 'Reserve',
    [EAppId.TE_STUDY_GUIDE]: 'Study Guide',
    [EAppId.TE_STUDY_PLANNER]: 'Study Planner',
    [EAppId.TE_VIEWER]: 'Viewer',
    [EAppId.TE_SEAT_MANAGEMENT]: 'Seat Management',
    [EAppId.TE_STATISTICS]: 'Statistics',
    // Supporting apps
    [EAppId.JAVA_CLIENT]: 'Java Client',
    [EAppId.TE_AM]: 'Activity Manager',
    [EAppId.TE_PORTAL]: 'Portal',
    [EAppId.TE_REST]: 'REST',
    [EAppId.TE_SERVER_THREAD]: 'Server Thread',
    [EAppId.TE_SOAP]: 'SOAP',
};
